import { KEYBOARD_KEY } from '@cxc/core/enums';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NgIconComponent } from '@ng-icons/core';

import { toggleableSignal } from '@utils/signals/toggleableSignal';

@Component({
  selector: 'caps-lock-component',
  templateUrl: './caps-lock.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgIconComponent],

  host: {
    '(window:keyup)': 'toggleIfCapsLock($event)',
  },
})
export class CapsLockComponent {
  capsLocked = toggleableSignal(false);

  toggleIfCapsLock(event: KeyboardEvent) {
    const isCapsLock = event.key === KEYBOARD_KEY.CapsLock;

    // Try to detect CapsLock state if possible
    // this is done so sentry doesent trigger the error that getModifierState is not a function
    const capsLockActive =
      typeof event.getModifierState === 'function'
        ? event.getModifierState(KEYBOARD_KEY.CapsLock)
        : false;

    if (isCapsLock) {
      // When CapsLock key is pressed, we can't trust getModifierState,
      // so toggle manually (this is imperfect but common)
      this.capsLocked.toggle();
    } else {
      // For other keys, trust the modifier state if available
      // This case scenario if the capslock was active before the component existed
      this.capsLocked.set(capsLockActive);
    }
  }
}
